import axios from 'axios';
import { authHeader } from '../helpers/authHeader';
const env = window.env;

export const fileService = {
	get
};

function get(authDocumentKey) {
	const requestConfig = {
		method: 'GET',
		url: `${env.BASE_API_URL}/create/pdf/${authDocumentKey}`,
		headers: Object.assign({}, authHeader())
	};

	return axios(requestConfig)
		.then(response => handleFileResponse(response))
		.catch(error => handleErrorResponse(error));
}

function handleFileResponse(response) {
	const data = response.data;

	if (data.length === 0) {
		return null;
	}

	return data;
}

function handleErrorResponse(error) {
	console.log(error); // eslint-disable-line
	return {error: 'Error: Network Error'};
}
